import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { DatePicker, Form, Input, InputNumber, Select, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import TuneIcon from "@mui/icons-material/Tune";
import { unwrapResult } from "@reduxjs/toolkit";
import locale from "antd/es/date-picker/locale/fr_FR";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import moment from "moment";

import { NavContext } from "../../../../App";
import {
  CANAL_OPTIONS_STRINGS,
  DELAI_RESOLUTION_OPTIONS_STRINGS,
  RATE_OPTIONS,
} from "../../../../constants";
import Snackbars from "../../../../GlobalComponents/Alerts/Snackbars";
import FiltreIcon from "../../../../GlobalComponents/IconComponents/FiltreIcon";
import { fetchChaines } from "../../../../ReduxTLK/features/Chaines/ChaineSlice";
import {
  fetchListPventesIntervenant,
  fetchPventes,
} from "../../../../ReduxTLK/features/Pointdeventes/PointdeventeSlice";
import {
  closeFilterBox,
  openFilterBox,
  resetFilter,
  resetFilterCounter,
  setFilterCounter,
  setFilterDraft,
  setFilterModel,
} from "../../../../ReduxTLK/features/SAV/FilterSlice";
import {
  array_machine,
  array_priorite,
  array_status,
} from "../../../../ReduxTLK/features/SAV/ticketList";
import { fetchFilteredTickets } from "../../../../ReduxTLK/features/SAV/TicketSlice";
import { ticketService } from "../../../../service/ticketService";
import RatiosCards from "../Ratios/RatiosCards";
import TicketBadges from "../TicketBadges/TicketBadges";

import styles from "./Filter.module.css";

const { RangePicker } = DatePicker;
const dateFormat = "MM-YYYY";

const EMPTY_FILTER_BODY = {
  id: null,
  chaineId: null,
  pointVenteId: null,
  statut: null,
  equipement: null,
  priorite: null,
  intervenantId: null,
  rate: null,
  canal: null,
  delaiRésolution: null,
  idAssignee: null,
  dateBegin: null,
  dateEnd: null,
};

export default function Filter(props) {
  const { nbrsOfTickets, ratios, notes } = props;

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const context = React.useContext(NavContext);

  const fetchFiltredModel = useSelector((state) => state.filter.filterModel);
  const savedFilterCounter = useSelector((state) => state.filter.counter);
  const savedFilterForm = useSelector((state) => state.filter.filter);
  const chaines = useSelector((state) => state.chaine.chaines);

  const [loading, setLoading] = useState(false);
  const [openErrorBox, setOpenErrorBox] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const [chaineId, setChaineId] = useState();
  const [pointDeVentes, setPointDeVentes] = useState([]);
  const [intervenant, setIntervenant] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [priorite, setPriorite] = useState();
  const [nbrePages, setNbrePages] = useState();

  useEffect(() => {
    if (savedFilterForm) {
      const processedFormData = {
        ...savedFilterForm,
        dateCreation: savedFilterForm.dateCreation
          ? savedFilterForm.dateCreation
            .map((d) => (d ? dayjs(d) : null))
            .filter((d) => d !== null)
          : null,
      };
      form.setFieldsValue(processedFormData);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchChaines());
  }, []);

  useEffect(() => {
    if (chaineId !== undefined && chaineId !== null) {
      dispatch(fetchPventes(chaineId))
        .then(unwrapResult)
        .then((res) => setPointDeVentes(res?.data?.data?.result));
    }
  }, [chaineId]);

  useEffect(() => {
    if (props.openFiltreBox) {
      dispatch(openFilterBox());
      props.fetchData({
        paginationModel: {
          page: fetchFiltredModel?.paginationModel?.page,
          pageSize: 8,
          nbPage: null,
        },
        body: { ...fetchFiltredModel.body },
      });
    } else {
      dispatch(closeFilterBox());
      props.fetchData({
        paginationModel: {
          page: fetchFiltredModel?.paginationModel?.page,
          pageSize: 12,
          nbPage: null,
        },
        body: { ...fetchFiltredModel.body },
      });
    }
  }, [props.openFiltreBox]);

  const handleBadgeClick = (badge) => {
    const filter = { ...fetchFiltredModel.body };
    if (badge.statut !== undefined && badge.statut !== null) {
      filter.statut = [badge.statut];
    } else {
      filter.statut = null;
    }
    onFinish(filter);
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("month");
  };

  const handleDateChange = (dates) => {
    if (dates?.length === 2) setSelectedDate(dates);
    else if (dates?.length === 1) setSelectedDate([dates[0], dates[0]]);
    else setSelectedDate([]);
  };

  const countNonNullFields = (obj) => {
    let count = 0;
    for (let key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) count++;
      else if (Array.isArray(obj[key])) continue;
      else if (obj[key] !== null && obj[key] !== undefined) count++;
    }
    return count;
  };

  const resetForm = () => {
    dispatch(resetFilterCounter());
    form.resetFields();
    setPointDeVentes([]);
    setIntervenant([]);
    setLoading(true);

    dispatch(
      fetchFilteredTickets({
        paginationModel: { page: 1, pageSize: 12, nbPage: null },
        body: EMPTY_FILTER_BODY,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        dispatch(
          setFilterModel({
            paginationModel: {
              page: res?.data?.pagination?.currentPage,
              pageSize: res?.data?.pagination?.pageSize,
              nbPage: res?.data?.pagination?.nbPage,
            },
            body: EMPTY_FILTER_BODY,
          })
        );
        setNbrePages(res?.data?.pagination?.nbPage);
        props.setTicketList(res?.data?.result?.tickets);
        setLoading(false);
        props.setFilterOptions(EMPTY_FILTER_BODY);
        props.setOpenFiltreBox(false);
        dispatch(closeFilterBox());
        dispatch(resetFilter());
      });
  };

  const onFinish = (values) => {
    setLoading(true);
    dispatch(setFilterDraft(values));
    dispatch(
      fetchFilteredTickets({
        paginationModel: { page: 1, pageSize: 12, nbPage: null },
        body: {
          ...values,
          dateBegin: props.dateBegin,
          dateEnd: props.dateEnd,
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        const nonNullFieldsCount = countNonNullFields({ ...values });
        dispatch(setFilterCounter(nonNullFieldsCount));
        dispatch(
          setFilterModel({
            paginationModel: {
              page: res?.data?.pagination?.currentPage,
              pageSize: res?.data?.pagination?.pageSize,
              nbPage: res?.data?.pagination?.nbPage,
            },
            body: {
              ...values,
              dateBegin: props.dateBegin,
              dateEnd: props.dateEnd,
            },
          })
        );
        setNbrePages(res?.data?.pagination?.nbPage);
        props.setTicketList(res?.data?.result?.tickets);
        setLoading(false);
        props.setOpenFiltreBox(false);
        dispatch(closeFilterBox());
      });
  };

  const onValuesChange = (changedValues, allValues) => {
    props.setFilterOptions(allValues);
    const [key, value] = Object.entries(changedValues)[0];

    if (key === "dateCreation" && value) {
      props.setDateBegin(value[0]?.startOf("month").format("YYYY-MM-DD"));
      props.setDateEnd(value[1]?.endOf("month").format("YYYY-MM-DD"));
    }

    if (key === "dateCreation" && !value) {
      props.setDateBegin();
      props.setDateEnd();
    }

    if (key === "priorite") setPriorite(value);

    if (key === "chaineId" && value !== undefined && value !== null) {
      form.setFieldsValue({
        chaineId: value,
        pointVenteId: null,
        intervenantId: null,
      });
      setIntervenant([]);
      setChaineId(value);
      dispatch(fetchPventes(value))
        .then(unwrapResult)
        .then((res) => setPointDeVentes(res?.data?.data?.result));
    }

    if (key === "chaineId" && (value === undefined || value === null)) {
      form.setFieldsValue({
        chaineId: null,
        pointVenteId: null,
        intervenantId: null,
      });
      setPointDeVentes([]);
      setIntervenant([]);
    }

    if (key === "pointVenteId" && (value !== undefined || value !== null)) {
      if (value?.length > 0) {
        dispatch(fetchListPventesIntervenant(value)).then((res) => {
          setIntervenant(res?.payload?.data?.data?.result);
        });
      } else {
        setPointDeVentes([]);
        setIntervenant([]);
      }
    }
  };

  const handleFiltreClick = () => {
    if (props.openFiltreBox === true) {
      props.setOpenFiltreBox(false);
      dispatch(closeFilterBox());
    } else {
      props.setOpenFiltreBox(true);
      dispatch(openFilterBox());
    }
  };

  const handleExportExcel = async () => {

    setLoading(true);
    ticketService.exportTicketsExcel(fetchFiltredModel.body).then((res) => {
      console.log("🚀 ~ handleExportExcel ~ res:", res)
      const url = window.URL.createObjectURL(new Blob([res?.data]));
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `export_ticket_${moment().format("DDMMYYYY_HHmmss")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch((error) => {
      setMessage("Une erreur est survenue lors de l'exportation.");
      setOpenErrorBox(true);
    }).finally(() =>
      setLoading(false)
    );
  };

  const validateIsInteger = (_, value) => {
    if (value && !Number.isInteger(value)) {
      return Promise.reject(new Error("Veuillez saisir un entier valide"));
    }
    return Promise.resolve();
  };

  const filterOption = (input, option) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  return (
    <div className={styles.wrapper}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {savedFilterCounter > 0 && (
            <span className={styles.counterPill}>
              <span className={styles.counterDot} />
              {savedFilterCounter} filtre{savedFilterCounter > 1 ? "s" : ""}{" "}
              appliqué{savedFilterCounter > 1 ? "s" : ""}
            </span>
          )}
          {ratios && (
            <RatiosCards ratios={ratios} notes={notes}  />
          )}
        </div>

        <div className={styles.headerRight}>
          <Button
            onClick={handleExportExcel}
            startIcon={<FileDownloadIcon sx={{ fontSize: 18 }} />}
            className={`${styles.headerBtn} ${styles.exportBtn}`}
            disableElevation
          >
            Export Excel
          </Button>
          <Button
            onClick={handleFiltreClick}
            startIcon={<FiltreIcon />}
            className={`${styles.headerBtn} ${styles.filterToggleBtn} ${props.openFiltreBox ? styles.filterToggleBtnActive : ""
              }`}
            disableElevation
          >
            Filtres
            {savedFilterCounter > 0 && (
              <span className={styles.btnBadge}>{savedFilterCounter}</span>
            )}
          </Button>
        </div>
      </div>

      {/* Filter panel */}
      {props.openFiltreBox && (
        <div className={styles.panel}>
          <div className={styles.panelHeader}>
            <div className={styles.panelTitle}>
              <span className={styles.panelTitleIcon}>
                <TuneIcon sx={{ fontSize: 16 }} />
              </span>
              Filtres avancés
            </div>
          </div>

          <Form
            form={form}
            name="control-hooks-filter"
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            layout="vertical"
          >
            <div className={styles.filterGrid}>
              {/* Référence */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Référence</label>
                <Form.Item
                  name="id"
                  rules={[
                    {
                      max: 100,
                      required: false,
                      validator: validateIsInteger,
                    },
                  ]}
                  className={styles.formItem}
                >
                  <InputNumber style={{ width: "100%" }} />
                </Form.Item>
              </div>

              {/* Entreprise */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Entreprise</label>
                <Form.Item name="chaineId" className={styles.formItem}>
                  <Select
                    allowClear
                    showSearch
                    filterOption={filterOption}
                    placeholder="Sélectionner"
                  >
                    {chaines &&
                      chaines.map((chaine) => (
                        <option key={chaine.id} value={chaine.id}>
                          {chaine.nom}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Établissement */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Établissement</label>
                <Form.Item name="pointVenteId" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    showSearch
                    filterOption={filterOption}
                    maxTagCount="responsive"
                  >
                    {pointDeVentes &&
                      pointDeVentes.map((pv) => (
                        <option key={pv.id} value={pv.id}>
                          {pv.nom}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Statut */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Statut</label>
                <Form.Item name="statut" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    showSearch
                    filterOption={filterOption}
                    maxTagCount="responsive"
                  >
                    {array_status &&
                      array_status
                        .filter(
                          (item) =>
                            item.id !== 7 && item.id !== 5 && item.id !== 8
                        )
                        .map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.nom}
                          </option>
                        ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Équipement */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Équipement</label>
                <Form.Item name="equipement" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    maxTagCount="responsive"
                    showSearch
                    filterOption={filterOption}
                  >
                    {array_machine &&
                      array_machine.map((machine) => (
                        <option key={machine.id} value={machine.id}>
                          {machine.nom}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Priorité */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Priorité</label>
                <Form.Item name="priorite" className={styles.formItem}>
                  <Select
                    mode="multiple"
                    placeholder="Sélectionner"
                    showSearch
                    filterOption={filterOption}
                    maxTagCount="responsive"
                  >
                    {array_priorite &&
                      array_priorite.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.nom}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Intervenant */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Intervenant</label>
                <Form.Item name="intervenantId" className={styles.formItem}>
                  <Select
                    mode="multiple"
                    showSearch
                    filterOption={filterOption}
                    maxTagCount="responsive"
                    placeholder="Sélectionner"
                  >
                    {intervenant.map((option, index) => (
                      <option key={index} value={option.id}>
                        {`${option.nom} ${option.prenom}`}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Date */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Date</label>
                <Form.Item name="dateCreation" className={styles.formItem}>
                  <RangePicker
                    allowClear
                    disabledDate={disabledDate}
                    picker="month"
                    size="middle"
                    placeholder={["MM-YYYY", "MM-YYYY"]}
                    locale={locale}
                    onChange={handleDateChange}
                    format={dateFormat}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </div>

              {/* Note */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Note</label>
                <Form.Item name="rate" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    maxTagCount="responsive"
                    showSearch
                    filterOption={filterOption}
                  >
                    {RATE_OPTIONS &&
                      RATE_OPTIONS.map((rate) => (
                        <option key={rate.value} value={rate.value}>
                          {rate.label}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Canal */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>Canal</label>
                <Form.Item name="canal" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    maxTagCount="responsive"
                    showSearch
                    filterOption={filterOption}
                  >
                    {CANAL_OPTIONS_STRINGS &&
                      CANAL_OPTIONS_STRINGS.map((canal) => (
                        <option key={canal.value} value={canal.value}>
                          {canal.label}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              {/* Estimation de la résolution */}
              <div className={styles.filterField}>
                <label className={styles.fieldLabel}>
                  Estimation de la résolution
                </label>
                <Form.Item name="delaiRésolution" className={styles.formItem}>
                  <Select
                    placeholder="Sélectionner"
                    mode="multiple"
                    maxTagCount="responsive"
                    showSearch
                    filterOption={filterOption}
                  >
                    {DELAI_RESOLUTION_OPTIONS_STRINGS &&
                      DELAI_RESOLUTION_OPTIONS_STRINGS.map((delai) => (
                        <option key={delai.value} value={delai.value}>
                          {delai.label}
                        </option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div className={styles.actionsRow}>
              <Button
                className={styles.resetBtn}
                onClick={resetForm}
                disabled={loading}
              >
                Réinitialiser
              </Button>
              <Button
                className={styles.confirmBtn}
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <span className={styles.loadingWrap}>
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 18, color: "#ffffff" }}
                          spin
                        />
                      }
                    />
                  </span>
                ) : (
                  "Appliquer les filtres"
                )}
              </Button>
            </div>
          </Form>
        </div>
      )}

      <Snackbars
        severity="success"
        message={message}
        open={open}
        setOpen={setOpen}
        autohideduration={1000}
      />
      <Snackbars
        severity="error"
        message={message}
        open={openErrorBox}
        setOpen={setOpenErrorBox}
        autohideduration={1000}
      />

      <div>
        <TicketBadges
          nbrsOfTickets={nbrsOfTickets}
          onBadgeClick={handleBadgeClick}
        />
      </div>
    </div>
  );
}